/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PageViewRequest
 */
export interface PageViewRequest {
  /**
   * The portal section opened, e.g. "shipments".
   * @type {string}
   * @memberof PageViewRequest
   */
  section: string;
}

/**
 * Check if a given object implements the PageViewRequest interface.
 */
export function instanceOfPageViewRequest(
  value: object,
): value is PageViewRequest {
  if (!("section" in value) || value["section"] === undefined) return false;
  return true;
}

export function PageViewRequestFromJSON(json: any): PageViewRequest {
  return PageViewRequestFromJSONTyped(json, false);
}

export function PageViewRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PageViewRequest {
  if (json == null) {
    return json;
  }
  return {
    section: json["section"],
  };
}

export function PageViewRequestToJSON(json: any): PageViewRequest {
  return PageViewRequestToJSONTyped(json, false);
}

export function PageViewRequestToJSONTyped(
  value?: PageViewRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    section: value["section"],
  };
}
